<template>
  <div class="feedback_drawer" >
    <el-tabs v-model="activeName" @tab-click="handleClick" style="margin: 10px 15px 0 15px;">
      <el-tab-pane label="我的消息" name="first"></el-tab-pane>
      <el-tab-pane label="随访反馈" name="second"></el-tab-pane>
      <el-tab-pane label="质控未通过提醒" name="third"></el-tab-pane>
    </el-tabs>
    <div style="text-align:right;padding: 0 15px;">
      <el-select size="medium" v-model="isRead" @change="searchMessage" placeholder="全部消息" clearable>
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="content_table" v-if="activeName=='first'">
      <div v-for="(item, index) in systemMessage" :key="item.id" class="sys_msg">
        <div class="sys_msg_top">
          <div class="left">
            <div class="image"  v-if="item.typeImageAddress">
              <img :src="item.typeImageAddressAfter" cover/>
            </div>
            <div v-else class="image" style="background: #0064E8;">
              <i class="el-icon-message-solid"></i>
            </div>
            <!-- {{ item.title }} -->
            <span v-html=" item.title"></span>
            <span v-if="!item.isRead" style="color: red">*</span>
          </div>
          <div class="time">{{ item.createTime }}</div>
        </div>
        <div class="content ql-editor"><div v-html="item.content"></div></div>
        <div v-if="!item.isConfirm" class="show_detail">
          <span style="cursor: pointer;" @click="sysMsgDialogOpen(item)">
          {{ item.classification == 1 ? '查看详情': '前去确认'}}
        </span></div>
        <div style="color:#ccc;cursor:pointer;" class="show_detail" v-else @click="sysMsgDialogOpen(item)">
          已确认
        </div>
      </div>
    </div>
    <div class="content_table" v-if="activeName=='second'">
      <el-collapse class="feedback_collapse" accordion v-model="activeNames" @change="handleChange">
        <el-collapse-item v-for="(item, index) in feedbackList" :key="index" :name="index" >
          <template slot="title">
            <span style="margin-right:10px;">{{ item.taskName }}</span>
            <el-tag type="success" v-if="item.isConfirm" size="mini">已读</el-tag>
            <el-tag type="danger" v-if="!item.isConfirm" size="mini">未读</el-tag>
          </template>
          <div>随访患者：{{item.patientName}}  反馈时间：{{item.feedBackTime}}</div>
          <div>结果：<span v-html="item.category"></span></div>
          <div>反馈问题：<span v-html="item.firstSpotCheckRemarks"></span></div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="content_table" v-if="activeName=='third'">
      <div v-for="(item, index) in passFailFeedBack" :key="index" class="sys_msg">
        <div class="feedBack_item" @click="clickHandler(item)">
          <div class="sys_msg_top">
            <div class="left">
              <div class="image image_third">质</div>
              {{item.followupPatientName}}
              <span v-if="!item.isConfirm" style="color: red">*</span>
            </div>
            <div class="time">{{ item.spotCheckTime }}</div>
          </div>
          <div class="content">
            <div>原因：{{ item.passFailReason }}</div>
            <div>任务： {{ item.followUpTaskName }}</div>
            <div>
              质控结果：{{ item.secondSpotCheckState == 1 ? '合格' : '不合格' }}·{{
                  item.handleResultName
                }}【{{ item.firstSpotCheckState }}<span>{{item.spotCheckRemarks}}</span>】
            </div>
          </div>
        </div>

      </div>
    </div>
    <el-pagination
      class="table_pagination"
      background
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :total="totalCount">
    </el-pagination>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  RestFeedbackOutControllerConfirmFeedbackById,
  RestFeedbackOutControllerGetFollowupTaskPatientInfo,
} from '@src/assets/js/api.js'

export default {
  name: 'feedback-drawer',
  data() {
    return {
      activeName:'first',
      isRead: null,
      options:[
        {value: true, label: '已读',},
        {value: false, label: '未读'},
      ],
      systemMessage:[], //我的消息-系统消息
      feedbackList:[], //随访反馈
      passFailFeedBack: [],//质控未通过提醒
      currentPage: 1,
      totalCount:1,
      pageSize:10,
      activeNames: null,
    }
  },
  computed: {
    ...mapGetters([
      "username",
      "userid",
    ]),
  },
  components: {},
  mounted() {
    this.onload()
  },
  methods: {
    onload(){
      this.currentPage = 1
      this.activeName = 'first'
      this.getSystemMessage()
    },
    handleClick(tab, event) {
      this.isRead=null
      this.activeName = tab.name
      this.currentPage=1
      this.totalCount=1
      this.searchList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.searchList()
    },
    searchMessage(){
      this.currentPage=1
      this.totalCount=1
      this.searchList()
    },
    searchList(){
      switch (this.activeName) {
        case 'first':
          this.getSystemMessage()
          break;
        case 'second':
          this.getFeedbackList()
          break;
        case 'third':
          this.getPassFailFeedBackList()
          break;
      }
    },//
    handleChange(val) {
      if (this.feedbackList[val]&&!this.feedbackList[val].isConfirm) {
        this.$store.dispatch('requestHandler',
          {
            fn: 'RestFeedbackOutControllerConfirmFeedbackById',
            params: { 
              userId: this.userid,
              id: this.feedbackList[val].id,
              spotCheckId: this.feedbackList[val].spotCheckId
            }
          }
        ).then(res => {
          if (res.status==0) {
            this.feedbackList[val].isConfirm = true;
          }
        })
      }
    },
    sysMsgDialogOpen(param){
      if (!param.isRead) { //未读
        this.$store.dispatch('requestHandler',
          {
            fn: 'RestCallCenterOperationPlatformControllerAddSystemMessageRead',
            params: { 
              seatId: this.userid,
              messageId: param.id,
            }
          }
        ).then(res => {
          if (res.status==0) {
            param.isRead = true;
          }
        })
      }
      this.$emit('openNotice',param)
    },
    // 质控未通过提醒
    clickHandler(param) {
      this.getFollowupTaskPatientInfoAsnyc({
        userId: this.userid,
        followupTaskId: param.followUpTaskId,
      }).then((res) => {
        if (res.status == 0) {
          localStorage.setItem('taskId', param.followUpTaskId)
          this.confirmFeedbackByIdAsync(param.id).then((res) => {
            this.$emit('closeDrawer')
            if (res.status == 0) {
              this.$router.push({
                path: '/internalQualityControl',
                query: {
                  adNo:param.admitNo
                }
              })
            }
          })
        } else {
          this.$message.error('暂无需要抽查任务')
        }
      })
    },
    // 我的消息
    getSystemMessage(){
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestCallCenterOperationPlatformControllerGetSystemMessage',
          params: { 
            seatId: this.userid,
            isRead:this.isRead,
            pageIndex:this.currentPage,
            pageSize: this.pageSize,
          }
        }
      ).then(res => {
        if (res.status==0) {
          this.systemMessage = res.retValue.map(item => {
            // 处理图片
            item.typeImageAddressAfter=""
            this.getPicUrl([item.typeImageAddress])
              .then(pic => {
                item.typeImageAddressAfter = pic[0]
              })
              return item
            })
          this.totalCount = res.totalCount
          this.currentPage = res.page
        }
      })
    },
    getPicUrl(picList){
      return new Promise((resolve) => {
        console.log(picList);
        this.$store.dispatch('getPicture', { url: picList }).then((res_) => {
         resolve(res_)
        })
      })
    },
    getFeedbackList(){
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestFeedbackOutControllerGetFeedbackList',
          params: { 
            seatId: this.userid,
            isRead:this.isRead,
            pageIndex:this.currentPage,
            pageSize: 15,
          }
        }
      ).then(res => {
        if (res.status==0) {
          this.feedbackList = res.retValue
          this.totalCount = res.totalCount
          this.currentPage = res.page
        }
      })
    },
    getPassFailFeedBackList(){
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestFeedbackOutControllerGetPassFailFeedBackList',
          params: { 
            userId:this.userid,
            isConfirm:this.isRead,
            pageIndex:this.currentPage,
            pageSize: this.pageSize,
          }
        }
      ).then(res => {
        if (res.status==0) {
          this.passFailFeedBack = res.retValue
        }
      })
    },
    // ==================================
    async confirmFeedbackByIdAsync(pid) {
      let request = new RestFeedbackOutControllerConfirmFeedbackById()
      request.p_id = pid
      await request.send()
      return request.result
    },

    async getFollowupTaskPatientInfoAsnyc(p) {
      let request = new RestFeedbackOutControllerGetFollowupTaskPatientInfo()
      request.p_followupTaskId = p.followupTaskId
      request.p_userId = p.userId
      await request.send()
      return request.result
    },
  },
}
</script>
<style lang="scss">
.sys_msg {
  strong {
    font-weight: bold !important;
  }
  .content p {
    line-height: 1;
  }
}
</style>
<style scoped lang="scss">
.feedback_drawer{
  position: relative;
  height:  calc(100vh - 10px);;
  .content_table {
    // padding: 10px 15px;
    height: calc(100vh - 150px);
    overflow: auto;
  }
  .table_pagination {
    position: absolute;
    bottom: 15px;
    left: 0;
  }
  .sys_msg {
    padding: 10px;
    strong {
      font-weight: 500;
    }
    &_top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        flex: 1;
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #000;
      }
      .image {
        width: 40px;
        height: 40px;
        margin-right: 10px;
        border-radius: 50%;
        color: #fff;
          text-align: center;
          line-height: 40px;
        &>i {
          font-size: 22px;
          margin-top: 8px;
        }
        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }
      }
      .image_third {
        background: #EE1048;
        font-weight: bold;
      }
      .time {
        font-size: 12px;
        color: #737171;
      }
    }
    
    .content {
      color: #737171;
      padding-left: 40px;
      font-size: 14px;
      line-height: 20px;
      word-break:break-all;
      display:-webkit-box;
      -webkit-line-clamp:4;
      -webkit-box-orient:vertical;
      overflow:hidden;

    }
    .show_detail {
      color: #4F9BFF;
      font-size:14px;
      text-align: right;
    }
    .feedBack_item:hover{
      background: #f4f4f4;
      cursor: pointer;
    }
  }
  .feedback_collapse {
    padding: 0 15px;
    font-size: 14px;
    color: #333;
  }
}

</style>